import React from 'react';
import { Table, TableProps } from 'antd';
import styles from './ModuleTable.module.css';

interface ModuleTableProps<T> extends Omit<TableProps<T>, 'dataSource' | 'loading'> {
  data: T[];
  loading?: boolean;
  emptyText?: string;
}

export const ModuleTable = <T extends object>({
  data,
  loading = false,
  emptyText = 'No data available',
  ...props
}: ModuleTableProps<T>) => {
  if (loading) {
    return (
    <>
      <div className={styles.loaderContainer}>
        <div className={styles.spinner}></div>
      </div>
    </>
    );
  }

  return (
    <Table
      {...props}
      dataSource={data}
      loading={false}
      locale={{ emptyText: <div style={{ margin: '20px 0' }}>{emptyText}</div> }}
      pagination={false}
      scroll={{ x: 'max-content', y: 550 }}
      className={styles['market-update-table']}
    />
  );
};  
